<div class="dialog fs-16">
  <div class="dialog-header flex_sb bg-fff">
    <div class="dialog-header-title fs-24 clr-333 fw-600 lh-130">
      {{ 'SHARED.EMAIL_INVOICE' | fallbackTranslate | titlecase }}
    </div>
    <div class="dialog-header-cross" (click)="onCancelClick()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>

  <div class="dialog__body">
    <form [formGroup]="validateForm" class="dialog__form">
      <div class="dialog__form-group">
        <label
          for="email"
          class="dialog__form-label fs-16 fw-600 lh-130 clr-666"
        >
          {{ 'SHARED.ENTER_THE_MAIL' | fallbackTranslate }}
        </label>
        <input
          nz-input
          class="dialog__input m-t-12"
          id="email"
          type="email"
          placeholder="{{ 'SHARED.ENTER_MAIL_H' | fallbackTranslate }}"
          formControlName="email"
        />
        <div
          class="dialog__error fs-14 lh-130 fw-400 m-t-6"
          *ngIf="
            validateForm.get('email')?.invalid &&
            validateForm.get('email')?.touched
          "
        >
          {{ 'SHARED.THE_INPT_MAIL' | fallbackTranslate }}
        </div>
      </div>
    </form>
  </div>
  <div class="dialog__footer">
    <button
      nz-button
      nzType="primary"
      nzSize="large"
      [nzLoading]="isLoading"
      (click)="sendEmail()"
      class="dialog__footer-save color-white fs-16 fw-600 lh-140 wd-100"
    >
      {{ 'SHARED.SEND' | fallbackTranslate | titlecase }}
    </button>
  </div>
</div>
